class PredictiveSearch extends HTMLElement {
    constructor() {
        super();
    
        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector('#predictive-search');
    
        this.input.addEventListener('input', this.debounce((event) => {
          this.onChange(event);
        }, 300).bind(this));
        
      }

      connectedCallback() {
        this.openSearchPop();
        this.closeSearchPop();
        this.backgroundClose();
      }
    
      onChange() {
        const searchTerm = this.input.value.trim();
    
        if (!searchTerm.length) {
            setTimeout(() => {
                this.serachEmpty();
            }, 100);
        }
    
        this.getSearchResults(searchTerm);
        this.onReset(searchTerm);
      }

      onReset(searchTerm) {
        let clearBtn = this.querySelector('.WI_searchCon_clean');
        console.log(searchTerm);
        if(searchTerm.length > 0) {
            clearBtn.style.visibility = 'visible';
            clearBtn.addEventListener('click', (e) => {
              e.preventDefault();
              this.input.value = '';
              this.serachEmpty();
          });
        }
      }
    
      getSearchResults(searchTerm) {
        let resultCon = this.querySelector('.WI_searchCon_result');
            console.log(resultCon);
            resultCon.style.display = 'flex';
            resultCon.classList.add('WI_searchCon_resultActive');
            setTimeout(() => {
                resultCon.style.opacity = "1";
            }, 10);
        fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
          .then((response) => {
            if (!response.ok) {
              var error = new Error(response.status);
            }
    
            return response.text();
          })
          .then((text) => {
            const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
            this.predictiveSearchResults.innerHTML = resultsMarkup;
            this.querySelector('.WI_searchCon_resultIn').style.opacity = "1";
            // document.dispatchEvent(new CustomEvent('wishRefresh', { bubbles: true }));
          })
          .catch((error) => {
            console.error(error);
          });
      }
    
      open() {
       
      }
    
      serachEmpty() {
        let resultCon = this.querySelector('.WI_searchCon_result');
        let clearBtn = this.querySelector('.WI_searchCon_clean');
        resultCon.style.opacity = "0";
        this.querySelector('.WI_searchCon_resultIn').style.opacity = "0";
        clearBtn.style.visibility = 'hidden';
        setTimeout(() => {
            resultCon.style.display = 'none';
            resultCon.classList.remove('WI_searchCon_resultActive');
            
        }, 310);
      }
    
      debounce(fn, wait) {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), wait);
        };
      }

      openSearchPop() {
        let searchOPener = document.querySelectorAll('.WI_searchOpen');
        searchOPener.forEach(srbtn => {
          srbtn.addEventListener('click', (e) => {
              e.preventDefault();
              this.style.display = 'block';
              console.log(searchOPener); 
              setTimeout(() => {
                  this.classList.add('wi-search_active');
                  this.querySelector('.WI_searchIn').style.top = '0';
                  this.querySelector('.WI_searchIn').style.opacity = '1';
                  requestAnimationFrame(() => {
                    this.querySelector("#Search").focus();
                  });
              }, 10);
          });
        });
      }

      closeSearchPop() {
        let searchOPener = document.querySelector('.WI_searchCon_close button');
        searchOPener.addEventListener('click', (e) => {
            e.preventDefault();
            this.classList.remove('wi-search_active');
            this.querySelector('.WI_searchIn').style.top = '-100%';
            this.querySelector('.WI_searchIn').style.opacity = '0';
            console.log(searchOPener); 
            setTimeout(() => {
                this.style.display = 'none';
            }, 310);
        });
      }

      backgroundClose(){
        const wiSearch = document.querySelector('wi-search');

        wiSearch.addEventListener('click', (e) => {
          const path = e.composedPath();
        
          // Only log if the click was directly on the host, not inside the shadow DOM
          if (path[0] === wiSearch && path[1] !== wiSearch.shadowRoot?.activeElement) {
            this.classList.remove('wi-search_active');
            this.querySelector('.WI_searchIn').style.top = '-100%';
            this.querySelector('.WI_searchIn').style.opacity = '0';
            setTimeout(() => {
                this.style.display = 'none';
            }, 310);
          }
        });
      }
}

customElements.define('wi-search', PredictiveSearch);